import React from "react"
import PropTypes from "prop-types"
import { get_secondary_image } from "./Helpers.js"

function tagLabel(tag) {
  if (!tag) return null

  return tag
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}

function finishLabel(finish) {
  if (!finish || finish === "regular") return null
  if (finish === "foil") return "Foil"
  if (finish === "foil_etched") return "Foil-Etched"
  if (!finish.includes("foil")) return null

  return finish
    .split(/[_\s]+/)
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}

class CardLink extends React.Component {
  metadataBadges() {
    const card = this.props.card
    const tags = Array.isArray(card.tags) ? card.tags : []
    const tagLabels = Array.isArray(card.tag_labels) ? card.tag_labels : []
    const badges = []

    if (this.props.showCardNum && card.card_num) {
      badges.push(<React.Fragment key="card-num"> <span className="card-num">#{card.card_num}</span></React.Fragment>)
    }

    tags.forEach((tag, index) => {
      const label = tagLabels[index] || tagLabel(tag)
      if (label) {
        badges.push(<React.Fragment key={`tag-${tag}`}> <span className="badge badge-variation">{label}</span></React.Fragment>)
      }
    })

    const hasFoilTag = tags.some(tag => tag === "foil" || tag.endsWith("-foil"))
    const finish = finishLabel(card.finish)
    if (!hasFoilTag && finish) {
      const className = card.finish === "foil" || card.finish === "foil_etched" ? "badge badge-foil" : "badge badge-variation"
      badges.push(<React.Fragment key={`finish-${card.finish}`}> <span className={className}>{finish}</span></React.Fragment>)
    }

    return badges
  }

  render () {
    var secondImage = get_secondary_image(this.props.card);

    const primaryImage =
      (this.props.card.source_image_variants && this.props.card.source_image_variants["265x370"]) || null;

    return (
      <React.Fragment>
        <span className='card_name'>
          <a
            data-card-id={this.props.card.name}
            data-full-image={primaryImage}
            { ...(secondImage && { "data-full-image1" : secondImage}) }
            rel="popover"
            href={this.props.card.links.default}
          >
            {this.props.card.display_name}
          </a>
          {this.metadataBadges()}
        </span>
      </React.Fragment>
    );
  }
}

CardLink.propTypes = {
  card: PropTypes.object,
  showCardNum: PropTypes.bool,
};

CardLink.defaultProps = {
  showCardNum: true,
};
export default CardLink
